import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import Row from '../../Common/Row';
import MetricInfoConstants from '../constants';
import Button from 'kingpin/atoms/Button';
import Sidebar from './Sidebar';
import MetricInformation from './MetricInformation';
import InfoHeading from './InfoHeading';
import { isNormalMetricInfo } from 'hooks/kpiTypeCheckers';
import Typography from 'kingpin/atoms/Typography';

const RightDiv = styled.div`
  height: ${MetricInfoConstants.POPUP_HEIGHT};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;
export const ContentDiv = styled.div`
  padding: 24px;

  flex: 1;
  overflow-y: auto;
`;

const InfoHeadingDiv = styled.div`
  padding: 12px 24px;

  border-bottom: 1px solid var(--color-border-secondary);
`;
const BottomBar = styled.div`
  padding: 12px 24px;

  border-top: 1px solid var(--color-border-secondary);
`;

const MetricInfoPopup = ({
  isSidebarVisible,
  metricInfos,
  selectedMetricInfo,
  onMetricInfoSelected,
  searchText,
  onSearchTextChanged,
  close,
}: {
  isSidebarVisible: boolean;
  metricInfos: MetricsInfoButton.MetricInfo[];
  selectedMetricInfo: MetricsInfoButton.MetricInfo;
  onMetricInfoSelected: (m: MetricsInfoButton.MetricInfo) => void;
  searchText: string;
  onSearchTextChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  close: () => void;
}) => (
  <Row style={{ position: 'relative' }}>
    <Sidebar
      metricInfos={metricInfos}
      searchText={searchText}
      onSearchTextChanged={onSearchTextChanged}
      onMetricInfoSelected={onMetricInfoSelected}
      isSidebarVisible={isSidebarVisible}
      selectedMetricInfo={selectedMetricInfo}
    />
    <RightDiv>
      <InfoHeadingDiv>
        <InfoHeading metricInfo={selectedMetricInfo} close={close} />
      </InfoHeadingDiv>
      <ContentDiv>
        {isNormalMetricInfo(selectedMetricInfo) ? (
          <MetricInformation metricInfo={selectedMetricInfo} />
        ) : (
          <Typography.Body type="Body 12">
            This KPI was entered manualy
          </Typography.Body>
        )}
      </ContentDiv>
      <BottomBar>
        <Row centerAlign style={{ justifyContent: 'flex-end' }}>
          <Button label="Close" onClick={close} type="Primary" size="Small" />
        </Row>
      </BottomBar>
    </RightDiv>
  </Row>
);

export default MetricInfoPopup;
